/* Geek Vacuums collection pages: vacuum-type filter and sort for the deal grids. Works on every [data-grid] on the page. */
(function () {
  var root = document.querySelector('.gv-deals');
  if (!root || root.__gvc) return;
  root.__gvc = true;

  var grids = Array.prototype.slice.call(root.querySelectorAll('[data-grid]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var sort = root.querySelector('[data-sort]');

  function filter(type) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-filter') === type ? 'true' : 'false'); });
    grids.forEach(function (g) {
      var shown = 0;
      Array.prototype.forEach.call(g.querySelectorAll('.dcard'), function (card) {
        var ok = type === 'all' || (' ' + card.getAttribute('data-type') + ' ').indexOf(' ' + type + ' ') > -1;
        card.hidden = !ok;
        if (ok) shown++;
      });
      g.setAttribute('data-count', shown);
      var none = g.parentNode.querySelector('[data-none]');
      if (none) none.hidden = shown > 0;
    });
  }

  function order(mode) {
    var key = mode.split('-')[0], dir = mode.split('-')[1] === 'desc' ? -1 : 1;
    grids.forEach(function (g) {
      var cards = Array.prototype.slice.call(g.querySelectorAll('.dcard'));
      cards.sort(function (a, b) {
        var x = +a.getAttribute('data-' + key), y = +b.getAttribute('data-' + key);
        return x === y ? (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos')) : (x - y) * dir;
      });
      cards.forEach(function (c) { g.appendChild(c); });
    });
  }

  chips.forEach(function (c) { c.addEventListener('click', function () { filter(c.getAttribute('data-filter')); }); });
  if (sort) sort.addEventListener('change', function () { order(sort.value); });
})();
